// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalAdd_form__2lmfM"};